"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _RedlineAuthorColorsContext = require("@common/components/remedy/RedlineAuthorColorsContext");
var _revision = require("@common/utils/redline/ooxml/revision");
var _proposedRevisions = require("@common/utils/redline/ooxml/proposed-revisions");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var REVISION_TAGS = new Set(["w:ins", "w:del", "w:moveTo", "w:moveFrom"]);
var UNKNOWN_AUTHOR_LABEL = "Unknown author";
var capitalizeWord = function capitalizeWord(word) {
  /**
   * WHEN word is empty
   *   CONSEQUENCE
   *     Return it unchanged: there is no first character to recase.
   */
  if (word.length === 0) return word;
  var plainCase = word === word.toLowerCase() || word === word.toUpperCase();
  /**
   * EXAMPLE
   *   word        = "ALICE"
   *   charAt(0)   -> "A"
   *   slice(1)    -> "LICE"
   *   toLowerCase -> "lice"
   *   result      -> "Alice"
   *
   * CASES
   *   - plainCase is true   -> uppercase first character, lowercase the rest
   *   - plainCase is false  -> keep mixed-case spelling as authored
   */
  return plainCase ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase() : word;
};
var properName = function properName(name) {
  return name.trim().split(/\s+/).map(function (part) {
    return part.split("-").map(capitalizeWord).join("-");
  }).join(" ");
};

/**
 * CASES
 *   - author is PROPOSED_REVISIONS_AUTHOR  -> keep that label verbatim
 *   - otherwise, properName(author) exists -> use the prettified name
 *   - otherwise                           -> use UNKNOWN_AUTHOR_LABEL
 */
var labelOf = function labelOf(author) {
  return author === _proposedRevisions.PROPOSED_REVISIONS_AUTHOR ? author : properName(author) || UNKNOWN_AUTHOR_LABEL;
};

/**
 * CASES
 *   - author is PROPOSED_REVISIONS_AUTHOR  -> the proposal highlight, the swatch the preview paints behind its words
 *   - otherwise                           -> the author's colour, the colour the preview paints their text in
 */
var swatchColorOf = function swatchColorOf(author, authorColorOf) {
  return author === _proposedRevisions.PROPOSED_REVISIONS_AUTHOR ? _proposedRevisions.PROPOSED_REVISIONS_HIGHLIGHT : authorColorOf(author);
};
var proposedFirst = function proposedFirst(left, right) {
  return Number(right.label === _proposedRevisions.PROPOSED_REVISIONS_AUTHOR) - Number(left.label === _proposedRevisions.PROPOSED_REVISIONS_AUTHOR);
};
var legendAuthors = function legendAuthors(ooxml, authorColorOf) {
  var parsed = new DOMParser().parseFromString(ooxml, "application/xml");
  var parserErrorNodes = parsed.getElementsByTagName("parsererror");
  var xmlParseErrorsExist = parserErrorNodes.length > 0;
  /**
   * WHEN XML parsing reported an error
   *   CONSEQUENCE
   *     Return no legend authors: the revision nodes are not trustworthy.
   */
  if (xmlParseErrorsExist) return [];
  var seen = new Set();
  var authors = [];
  for (var _i = 0, _Array$from = Array.from(parsed.getElementsByTagName("*")); _i < _Array$from.length; _i++) {
    var _node$getAttribute;
    var node = _Array$from[_i];
    var nodeIsRevisionTag = REVISION_TAGS.has(node.nodeName);
    /**
     * WHEN node.nodeName is not in REVISION_TAGS
     *   CONSEQUENCE
     *     Skip it: only tracked revision elements contribute legend authors.
     */
    if (!nodeIsRevisionTag) continue;
    var author = (_node$getAttribute = node.getAttribute("w:author")) !== null && _node$getAttribute !== void 0 ? _node$getAttribute : "";
    var authorKey = _revision.Revision.authorKey(author);
    /**
     * WHEN authorKey is already in seen
     *   CONSEQUENCE
     *     Skip this node so one normalized author key yields one legend entry.
     */
    if (seen.has(authorKey)) continue;
    seen.add(authorKey);
    var authorLabel = labelOf(author);
    var authorColor = swatchColorOf(author, authorColorOf);
    var legendAuthor = {
      authorKey: authorKey,
      label: authorLabel,
      color: authorColor
    };
    authors.push(legendAuthor);
  }
  return authors.sort(proposedFirst);
};
var legendAuthorsWith = function legendAuthorsWith(ooxml, alwaysListedAuthors, authorColorOf) {
  var authors = legendAuthors(ooxml, authorColorOf);
  var seen = new Set(authors.map(function (author) {
    return author.authorKey;
  }));
  var _iterator = _createForOfIteratorHelper(alwaysListedAuthors),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var author = _step.value;
      var authorKey = _revision.Revision.authorKey(author);
      if (seen.has(authorKey)) continue;
      seen.add(authorKey);
      authors.push({
        authorKey: authorKey,
        label: labelOf(author),
        color: swatchColorOf(author, authorColorOf)
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return authors.sort(proposedFirst);
};
var RevisionLegend = function RevisionLegend(_ref) {
  var ooxml = _ref.ooxml,
    alwaysListedAuthors = _ref.alwaysListedAuthors,
    authorColorOverride = _ref.authorColorOf;
  var alwaysListedKey = alwaysListedAuthors.join("|");
  var colorOfAuthor = (0, _RedlineAuthorColorsContext.useRedlineAuthorColor)();
  var authorColorOf = authorColorOverride !== null && authorColorOverride !== void 0 ? authorColorOverride : colorOfAuthor;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  var authors = (0, _react.useMemo)(function () {
    return legendAuthorsWith(ooxml, alwaysListedAuthors, authorColorOf);
  }, [ooxml, alwaysListedKey, authorColorOf]);
  /**
   * WHEN there are no legend authors
   *   CONSEQUENCE
   *     Render nothing so the legend row does not appear empty.
   *
   * NULL
   *   No RevisionLegend markup. The caller should omit this section entirely.
   */
  if (authors.length === 0) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "mb-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-[#4B5563]",
    "data-sentry-component": "RevisionLegend",
    "data-sentry-source-file": "RevisionLegend.tsx",
    children: authors.map(function (author) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
        className: "inline-flex items-center gap-1",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          "aria-hidden": "true",
          className: "inline-block h-2.5 w-2.5 rounded-sm",
          style: {
            background: author.color
          }
        }), author.label]
      }, author.authorKey);
    })
  });
};
var _default = exports.default = RevisionLegend;